import { createFeatureSelector, createSelector } from '@ngrx/store';

import { KEYBOARD_FEATURE_KEY, KeyboardState } from './keyboard.reducer';

const getState = createFeatureSelector<KeyboardState>(KEYBOARD_FEATURE_KEY);

export const getShowHelp = createSelector(getState, (s) => s.showHelp);
